// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"9932f68c6974060d","444":"416af507dd5ce282","457":"9db323391075f828","777":"dcd1f0ea2984c90c"}[chunkId] + ".js";
};